import moment from "moment";

export const predefinedRanges = [
  {
    id: "LAST_HOUR",
    displayName: "Last Hour",
    dateTimeRange: () => {
      return {
        startDate: moment().subtract(1, "hour").toDate(),
        endDate: moment().toDate(),
      };
    },
  },
  {
    id: "LAST_X_HOURS",
    displayName: "Last X Hours",
    selectedDisplayName: ["Last", "Hours"],
    hasArgument: true,
    dateTimeRange: (x) => {
      return {
        startDate: moment().subtract(x, "hour").toDate(),
        endDate: moment().toDate(),
      };
    },
  },
  {
    id: "TODAY",
    displayName: "Today",
    dateTimeRange: () => {
      return {
        startDate: moment().startOf("day").toDate(),
        endDate: moment().endOf("day").toDate(),
      };
    },
  },
  {
    id: "YESTERDAY",
    displayName: "Yesterday",
    dateTimeRange: () => {
      const yesterday = moment().subtract(1, "days");
      return {
        startDate: yesterday.startOf("day").toDate(),
        endDate: yesterday.endOf("day").toDate(),
      };
    },
  },
  {
    id: "X_DAYS_AGO",
    displayName: "X Days Ago",
    selectedDisplayName: ["", "Days Ago"],
    dateTimeRange: (x) => {
      const date = moment().subtract(x, "days");
      return {
        startDate: date.startOf("day").toDate(),
        endDate: date.endOf("day").toDate(),
      };
    },
    hasArgument: true,
  },
];
